export default __webpack_public_path__ + "static/media/me-min.03866606.png";